import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
export const useReportPaymentBtnDisabledEffect = ({
  footerButtonStatuses,
  t,
  setIsReportPaymentBtnDisabled,
}) => {
  useEffectWithErrorLogging(() => {
    if (
      footerButtonStatuses.find(
        (btn) =>
          btn.btnName ===
            t('reportUsage.reportUsageFooterbuttons.reviewButton') &&
          btn.btnVisibility &&
          !btn.isBtnDisable
      )
    ) {
      setIsReportPaymentBtnDisabled(false);
    } else {
      setIsReportPaymentBtnDisabled(true);
    }
  }, [footerButtonStatuses]);
};